import { useTranslation } from "react-i18next";
import toneIcon from "../../../static/assets/Tone.png";

const StatCard = ({ label, value, iconClass, iconImage }) => (
  <div className="bg-white rounded-lg border border-[#d3d3d3] flex items-center flex-1 h-[84px]">
    <div className="flex-shrink-0 ml-6 mr-6 flex items-center justify-center">
      <div className="w-[52px] h-[52px] rounded-lg bg-[#E7F8F1] flex items-center justify-center">
        {iconImage ? (
          <img src={iconImage} alt={label} className="w-[24px] h-[24px]" />
        ) : (
          <i
            className={`${iconClass} text-[#00A7A6] text-[22px]`}
            style={{ transform: "scale(0.8)" }}
          />
        )}
      </div>
    </div>
    <div className="flex flex-col justify-center">
      <p className="text-[14px] leading-[22px] text-[#222222] mb-0">{label}</p>
      <p className="text-[24px] leading-[24px] font-semibold text-[#222222] mt-0">
        {value}
      </p>
    </div>
  </div>
);
const StatsCards = ({
  recoverablePercentage,
  withChannelPercentage,
  withoutChannelPercentage,
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-6 mt-0 mb-6">
      <StatCard
        icon="shopping-bag"
        label={t("Recoverable materials")}
        value={`${recoverablePercentage ?? "0,0"}%`}
        iconImage={toneIcon}
      />
      <StatCard
        icon="check"
        label={t("With channel")}
        value={`${withChannelPercentage ?? "0,0"}%`}
        iconClass="fas fa-check"
      />
      <StatCard
        icon="times"
        label={t("Without channel")}
        value={`${withoutChannelPercentage ?? "0,0"}%`}
        iconClass="fas fa-times"
      />
    </div>
  );
};
export default StatsCards;
